// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mq-2";
export var interactiveWrapper = "_mq-0";
export var shippingHoverPreview = "_mq-4";
export var summaryBadgeTrigger = "_mq-1";
export var widgetHoverPreviewList = "_mq-3";
export var widgetPreviewScale = "_mq-5";